<template>
  <div class="w-full h-full max-w-[1920px] grid grid-cols-2 flex-col flex-nowrap">
    <div
      class="h-1/2 md:h-full flex justify-center items-center col-span-2 md:col-span-1 w-full"
      style="min-height: 400px"
    >
      <AppErrorImage
        :code="error.code"
        class="h-full"
        dark-color="var(--p-primary)"
        light-color="var(--p-primary-light)"
      />
    </div>
    <div
      class="flex w-10/12 mx-auto flex-col justify-center items-end md:h-full h-1/2 col-span-2 md:col-span-1"
    >
      <h4
        class="text-6xl md:text-8xl text-dark-error"
        style="width: fit-content; text-align: right"
      >
        <span class="flex w-full items-end justify-end gap-3">
          <Tag
            class="uppercase text:2xl md:text-4xl md:h-[3rem] h-1.5rem md:mb-6 mb-3"
            :severity="serverError ? 'danger' : 'warn'"
            :value="serverError ? $t('Server') : $t('Client')"
          />
          {{ error.code }}
        </span>
        <span>
          {{ error.message }}
        </span>
      </h4>
      <p
        class="text-3xl flex flex-col items-end text-dark-error"
        style="width: fit-content; text-align: right; max-width: 450px"
      >
        {{ error.perex ? `${error.perex}.` : '' }}
      </p>
      <p class="text-lg">{{ time }}</p>
      <div class="mt-8 flex flex-col items-end">
        <p class="text-4xl text-dark-error text-right">{{ $t('What do you want to do now?') }}</p>
        <div class="text-xl flex flex-col items-end text-end" style="max-width: 420px">
          <p class="text-end" style="width: fit-content; white-space: pre-wrap; text-align: right">
            {{ error.help ? `*${error.help}` : '' }}
          </p>
        </div>
        <div class="flex gap-2 mt-4">
          <Button
            v-if="$auth.auth.value.token"
            :label="$t('Go back')"
            class="bg-white"
            size="large"
            outlined
            @click="goBack"
          />
          <Button v-if="error.code === 401" :label="$t('Sign in')" size="large" @click="goLogin" />
          <Button v-else :label="$t('Go to the homepage')" size="large" @click="goHome" />
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
const props = withDefaults(defineProps<{ code: string; serverError?: boolean }>(), {
  serverError: false,
})
const { $auth } = useNuxtApp()
const codes = getStatusCodes()
const router = useRouter()
const error = codes[props.code]

const time = Intl.DateTimeFormat('cs-cz', { timeStyle: 'short', dateStyle: 'medium' }).format(
  new Date()
)

const { clearError } = useErrors()

const goBack = () => {
  clearError({ redirect: window.history.state.back })
}
const goHome = () => {
  const homePage = router.getRoutes().find((r) => r.meta.loginPage === true)
  if (!homePage) {
    console.warn('No home page found, redirecting to /')
  }
  clearError({ redirect: homePage?.path ?? '/' })
}

const goLogin = () => {
  if ($auth.auth.value.token) {
    $auth.logout()
  }
  const loginPage = router.getRoutes().find((r) => r.meta.loginPage === true)
  if (!loginPage) {
    console.warn('No login page found, redirecting to /login')
  }
  clearError({ redirect: loginPage?.path || '/login' })
}
</script>
